import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSelectWall = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 27,
	height: 31,
	viewBox: "0 0 27 31",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M2 6.50818L25.4098 1.22949",
			stroke: "#545454",
			strokeWidth: 2.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.22949 28.7706L25.6393 19.8198",
			stroke: "#545454",
			strokeWidth: 2.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25.4102 20.2788L25.4102 1.00012",
			stroke: "#545454",
			strokeWidth: 2.5
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 1.66797,
			y1: 29,
			x2: 1.66797,
			y2: 6.04918,
			stroke: "#545454",
			strokeWidth: 2.5
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 25.5879,
			y1: 1.14517,
			x2: 3.09611,
			y2: 28.6862,
			stroke: "currentColor",
			strokeWidth: .459016
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 2.57707,
			y1: 6.3115,
			x2: 25.5279,
			y2: 20.082,
			stroke: "currentColor",
			strokeWidth: .459016
		})
	]
});
export default SvgSelectWall;
